import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["cinemaInput", "dropdown"]

  selectCinema(event) {
    event.preventDefault()

    this.cinemaInputTarget.value = event.currentTarget.dataset.cinemaId
    this.cinemaInputTarget.dispatchEvent(new InputEvent("input", { bubbles: true }))
    this.dropdownTarget.classList.add("hidden")
  }
}
